import {
  RadioAction,
  RadioType,
  StandardAction,
} from '@infodata-group/inf-commons';
import { of } from 'rxjs';

export class RadioActionBuilder {
  private readonly _name: string = '';
  private readonly _icon: string = '';
  private _text: string = '';
  private _type: RadioType = RadioType.CLASSIC;
  private _align: 'left' | 'center' | 'right' = 'left';
  private _tooltip: string = '';
  private _isFirstActionDefaultValue = false;
  private _actions: StandardAction[] = [];
  constructor(name: string, icon = '') {
    this._name = name;
    this._icon = icon;
  }
  public addAction(action: StandardAction): RadioActionBuilder {
    this._actions.push(action);
    return this;
  }
  public setText(text: string): RadioActionBuilder {
    this._text = text;
    return this;
  }
  public setType(type: RadioType): RadioActionBuilder {
    this._type = type;
    return this;
  }
  public setAlign(align: 'left' | 'center' | 'right'): RadioActionBuilder {
    this._align = align;
    return this;
  }

  public setTooltip(tooltip: string): RadioActionBuilder {
    this._tooltip = tooltip;
    return this;
  }
  public setFirstActionDefaultValue(): RadioActionBuilder {
    this._isFirstActionDefaultValue = true;
    return this;
  }
  public build(): RadioAction {
    const action = new RadioAction(
      this._name,
      this._icon,
      of(this._actions),
      this._text,
      this._type,
    );
    action.align = this._align;
    action.tooltip = this._tooltip;
    if (this._isFirstActionDefaultValue && this._actions.length > 0) {
      action.currentValue = this._actions[0];
    }
    return action;
  }
}
